const state= {
    PostingEntryItems:{
      items:[],
      total:0,
    },
    GLAccountNameItems:{
      items:[],
      total:0,
    },
    NavisionFileItems:{
      items:[],
      total:0,
    },
    TransactionTypesItems:{
      items:[],
      total:0,
    },
    GLAccountNameInput : {
      items:[],
      total:0,
    },
    TransactionTypesInput: {
      items:[],
      total:0,
    },
    NavisionFileInput: {
      items:[],
      total:0,
    },
};

const getters = {
    PostingEntryItems : (state) => state.PostingEntryItems,
    GLAccountNameItems : (state) => state.GLAccountNameItems,
    NavisionFileItems : (state) => state.NavisionFileItems,
    TransactionTypesItems : (state) => state.TransactionTypesItems,
    GLAccountNameInput : (state) => state.GLAccountNameInput,
    TransactionTypesInput : (state) => state.TransactionTypesInput,
    NavisionFileInput : (state) => state.NavisionFileInput,
};

const actions = {
    /*Posting Rule*/
    async getPostingEntryItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/posting-entry`, {params:params})
            .then(response => {
                    commit( 'SET_POSTING_ENTRY_LIST', response.data.data );
                    resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async savePostingEntry({commit}, params){

        return new Promise((resolve, reject) => {
            if(params.id){
                global.axios.put(`api/posting-entry/` + params.id, {
                    txn_code: params.txn_code,
                    posting_type: params.posting_type,
                    txn_description: params.txn_description,
                    txn_account_type: params.txn_account_type,
                    credit: params.credit,
                    debit: params.debit,
                    tax_on: params.tax_on,
                    remark: params.remark
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }else{
                global.axios.post(`api/posting-entry`,{
                    txn_code: params.txn_code,
                    posting_type: params.posting_type,
                    txn_description: params.txn_description,
                    txn_account_type: params.txn_account_type,
                    credit: params.credit,
                    debit: params.debit,
                    tax_on: params.tax_on,
                    remark: params.remark
                })
                .then(response => {
                    commit( 'CREATE_POSTING_ENTRY', response.data.data );
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }
        });
    },
    import({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file_import',params.fileImport);
            global.axios.post(`api/posting-entry/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    async deletePostingEntry({commit}, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/posting-entry`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
    /*Navision File*/
    async getNavisionFileItems({commit}, params){
        let isCMS = params.isCMS || '';
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        let contract_id = params.contract_id || -1;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/navision-file-names`, {params:{
                isCMS:isCMS,
                page:page,
                limit:limit,
                filter:filter,
            }})
            .then(response => {
                let mutations = 'SET_NAVISION_FILE_LIST';
                if(params.is_store) {
                    mutations = 'SET_NAVISION_FILE_INPUT';
                }
                commit( mutations, response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async saveNavisionFile({commit}, params){

        return new Promise((resolve, reject) => {
            if(params.id){
                global.axios.put(`api/navision-file-names/` + params.id, {
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }else{
                global.axios.post(`api/navision-file-names`,{
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }
        });
    },
    async deleteNavisionFile({commit}, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/navision-file-names`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
    /*Transaction Types*/
    async getTransactionTypesItems({commit}, params){
        let isCMS = params.isCMS || '';
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        let contract_id = params.contract_id || -1;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/gl-transaction-types`, {params:{
                isCMS:isCMS,
                page:page,
                limit:limit,
                filter:filter,
            }})
            .then(response => {
                let mutations = 'SET_TRANSACTION_TYPES_LIST';
                if(params.is_store) {
                    mutations = 'SET_TRANSACTION_TYPES_INPUT';
                }
                commit( mutations, response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async saveTransactionTypes({commit}, params){

        return new Promise((resolve, reject) => {
            if(params.id){
                global.axios.put(`api/gl-transaction-types/` + params.id, {
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }else{
                global.axios.post(`api/gl-transaction-types`,{
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }
        });
    },
    async deleteTransactionTypes({commit}, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/gl-transaction-types`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
    /*GL Account Names*/
    async getGLAccountNamesItems({commit}, params){
        let isCMS = params.isCMS || '';
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        let contract_id = params.contract_id || -1;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/gl-account-names`, {params:{
                isCMS:isCMS,
                page:page,
                limit:limit,
                filter:filter,
            }})
            .then(response => {
                let mutations = 'SET_GL_ACCOUNT_NAME_LIST';
                if(params.is_store) {
                    mutations = 'SET_GL_ACCOUNT_NAME_INPUT';
                }
                commit( mutations, response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async saveGLAccountNames({commit}, params){

        return new Promise((resolve, reject) => {
            if(params.id){
                global.axios.put(`api/gl-account-names/` + params.id, {
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }else{
                global.axios.post(`api/gl-account-names`,{
                    name: params.name
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
            }
        });
    },
    async deleteGLAccountNames({commit}, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/gl-account-names`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
}

const mutations = {
    SET_POSTING_ENTRY_LIST(state, data) {
        state.PostingEntryItems = data;
    },
    SET_GL_ACCOUNT_NAME_LIST(state, data) {
        state.GLAccountNameItems = data;
    },
    SET_GL_ACCOUNT_NAME_INPUT(state, data) {
        state.GLAccountNameInput = data;
    },
    SET_NAVISION_FILE_LIST(state, data) {
        state.NavisionFileItems = data;
    },
    SET_NAVISION_FILE_INPUT(state, data) {
        state.NavisionFileInput = data;
    },
    SET_TRANSACTION_TYPES_LIST(state, data) {
        state.TransactionTypesItems = data;
    },
    SET_TRANSACTION_TYPES_INPUT(state, data) {
        state.TransactionTypesInput = data;
    },
    CREATE_POSTING_ENTRY(state, data) {
        state.PostingEntryItems = [...state.PostingEntryItems.items, data];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
